export enum NotificationResourceTypeEnum {
  EVENT_PARTICIPANT_ID = 'EVENT_PARTICIPANT_ID',
  EVENT_ID = 'EVENT_ID',
  CLASSEMENT_EVENT_ID = 'CLASSEMENT_EVENT_ID',
  DATE_MATCH = 'DATE_MATCH',
  EVENT_NAME = 'EVENT_NAME',
  TEAM_NAME = 'TEAM_NAME',
  STRUCTURE_ID = 'STRUCTURE_ID',
  STRUCTURE_PROFIL_ID = 'STRUCTURE_PROFIL_ID',
  STRUCTURE_NAME = 'STRUCTURE_NAME',
  RELATION_ID = 'RELATION_ID',
  TEAM_ID = 'TEAM_ID',
  CONVERSATION_ID = 'CONVERSATION_ID',
  MATCH_EVENT_ID = 'MATCH_EVENT_ID',
  NAME_TEAM_1 = 'NAME_TEAM_1',
  NAME_TEAM_2 = 'NAME_TEAM_2',
  SCORE_TEAM_1 = 'SCORE_TEAM_1',
  PLACE_TEAM_1 = 'PLACE_TEAM_1',
  SCORE_TEAM_2 = 'SCORE_TEAM_2',
  FINAL_PLACE = 'FINAL_PLACE',
}
